angular.module('theme').directive('analytics', function (TrackerService) {
	return {
		restrict: 'A',
		link: function ($scope, $element, $attrs) {
			var eventType = $attrs.analytics || 'click';

			angular.element($element[0]).bind(eventType, function () {
				var category = $attrs.analyticsCategory;
				var action = $attrs.analyticsAction;
				var label = $attrs.analyticsLabel;
				var value = $attrs.analyticsValue;
				TrackerService.event(category, action, label, value);
			});
		}
	};
});
